// client/src/lib/contactFirms.js
// A contact's firms, in display order. The server builds `firms` (see
// src/lib/contactFirms.js: all links equal, RGA first for partners, then by
// name); endpoints that don't send it yet fall back to primary_firm alone.

export function firmsOf(c) {
  if (Array.isArray(c?.firms)) return c.firms
  return c?.primary_firm ? [c.primary_firm] : []
}

export function firmNames(c) {
  return firmsOf(c).map(f => f.name).join(', ')
}

// For table cells: one firm per line.
export function FirmLines({ contact }) {
  const firms = firmsOf(contact)
  if (!firms.length) return '—'
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      {firms.map(f => <div key={f.firm_id}>{f.name}</div>)}
    </div>
  )
}
